module.exports = __webpack_public_path__ + "static/media/linux.912119be.svg";